import { render, staticRenderFns } from "./PunchCriteriaType.vue?vue&type=template&id=20eb2870&"
import script from "./PunchCriteriaType.vue?vue&type=script&lang=js&"
export * from "./PunchCriteriaType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20eb2870')) {
      api.createRecord('20eb2870', component.options)
    } else {
      api.reload('20eb2870', component.options)
    }
    module.hot.accept("./PunchCriteriaType.vue?vue&type=template&id=20eb2870&", function () {
      api.rerender('20eb2870', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Page/EssAdmin/Punch/PunchCriteriaType/PunchCriteriaType.vue"
export default component.exports